/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAssignCustomRoles: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-assign-custom-roles", jiraSpaEntry: "async-jira-eoc-assign-custom-roles" */ '@jira/eoc__assign-custom-roles/src/index.tsx'
		),
);

const AsyncAssignCustomRoles = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAssignCustomRoles}
		pageId="async-eoc-assign-custom-roles"
		shouldShowSpinner={false}
	/>
);

export default AsyncAssignCustomRoles;
